import React, { Component } from 'react'
import { Row, Col, Icon, Divider, Button, Modal, Select, Input, Table, message, Typography } from 'antd'
import { connect } from 'react-redux'

import './style.css';

import { 
    get_ch_department, 
    save_checklist, 
    get_checklist, 
    delete_checklist,
    update_checklist_department,
    update_checklist,
    update_checklist_type } from './actions/checklist.action';

let timer,x;
const { confirm } = Modal;
const { TextArea } = Input;
const dateFormat = 'YYYY/MM/DD';
const Option = Select.Option;
const { Paragraph } = Typography;

class CheckList extends Component {

    constructor( props ){
        super( props );

        this.state = {
            data: [],
            new_visible: false,
            departments: [],
            department_id: 0,
            check_list_name: '',
            check_list_type: 'e_x_c',
            pagination: 1,
            department_filter: [{ text: '', value: '' }]
        };

        this.handleSubmit = this.handleSubmit.bind( this );
        this.handleCancel = this.handleCancel.bind( this );
        this.handleDeleteChecklist = this.handleDeleteChecklist.bind( this );
        this.handleUpdateDepartment = this.handleUpdateDepartment.bind( this );
        this.handleUpdateChecklist = this.handleUpdateChecklist.bind( this );
        this.handleUpdateChecklistType = this.handleUpdateChecklistType.bind( this );
        this.getColumnSearchProps = this.getColumnSearchProps.bind( this );
    
    }

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => this.handleSearch(selectedKeys, confirm)}
                    icon="search"
                    size="small"
                    style={{ width: 90, marginRight: 8 }}>
                    Search
                </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>Reset</Button>
            </div>
        ),
        filterIcon: filtered => (
            <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
                if (visible) {
                    setTimeout(() => this.searchInput.select() );
                }
        }
    });

    handleSearch = (selectedKeys, confirm) => {
        confirm();
        this.setState({ searchText: selectedKeys[0] });
    }
    
    handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });
    }

    handleUpdateChecklistType( value, id ){
        this.props.update_checklist_type( value, id );

    }

    handleUpdateChecklist( value, id ){
        this.props.update_checklist( value, id );
    }

    handleUpdateDepartment( value, id ){
        this.props.update_checklist_department( value, id );
    }

    handleDeleteChecklist( check_list_id ){
        let self = this;
        confirm({
            title: 'Do you want to delete?',
            onOk() {
                self.props.delete_checklist( check_list_id );
            },
            onCancel() {
                // Nothing
            },
        });

        
    }

    handleCancel(){
        this.setState({ new_visible: false });
    }

    handleSubmit(){

        let temp = {
            department_id: this.state.department_id,
            check_list_type: this.state.check_list_type,
            check_list_name: this.state.check_list_name
        }

        if( this.state.department_id !== 0 &&
            this.state.check_list_name !== '' && this.state.check_list_type !== '' ){

            this.props.save_checklist( temp );
            this.setState({ new_visible: false, check_list_name: '', department_id: 0 });
        
        } else {
            message.error( "All fields are mandatory" );

        }

    }

    componentDidMount(){
        this.props.get_ch_department();
        this.props.get_checklist();
    }

    componentWillReceiveProps( nextProps ){

        if( nextProps.checklist.length !== 0 ){

            if( nextProps.checklist.STATUS.CODE === '200' &&
                nextProps.checklist.STATUS.MESSAGE === 'Successfully Listed Department' ){
                    
                let temp_data = [];
                
                nextProps.checklist.OUTPUT.DATA.map( ( item, value ) => {
                    temp_data.push( {text: item.department_name, value: item.department_name } ); 
                })
                
                this.setState({ 
                    departments: nextProps.checklist.OUTPUT.DATA,
                    department_filter: temp_data
                });

            }

            if( nextProps.checklist.STATUS.CODE === '200' &&
                nextProps.checklist.STATUS.MESSAGE === 'Successfully Saved Check list' ){
                this.props.get_ch_department();
                this.props.get_checklist();
            }

            if( nextProps.checklist.STATUS.CODE === '200' &&
                nextProps.checklist.STATUS.MESSAGE === 'Successfully Listed Check List' ){
                this.setState({ data: nextProps.checklist.OUTPUT.DATA });
            }

            if( nextProps.checklist.STATUS.CODE === '200' &&
                nextProps.checklist.STATUS.MESSAGE === 'Successfully Deleted Check List' ){
                this.props.get_ch_department();
                this.props.get_checklist();
                message.success( nextProps.checklist.STATUS.MESSAGE );
            }

            if( nextProps.checklist.STATUS.CODE === '200' &&
                nextProps.checklist.STATUS.MESSAGE === 'Successfully Updated' ){
                message.success( nextProps.checklist.STATUS.MESSAGE );
                this.props.get_checklist();
            }

            if( nextProps.checklist.STATUS.CODE === '400' ){
                // message.error( nextProps.checklist.STATUS.MESSAGE );
            }

        }

    }

    render() {

        const departments_list = this.state.departments.map( 
                ( key, item ) => <Option value={ key.department_id }>{ key.department_name }</Option> )

        const columns = [
            {
                title: 'Department',
                key: 'department_name',
                render: ( data ) => <span>
                    <Select
                        onChange={ (value) => this.handleUpdateDepartment( value, data.check_list_id ) }
                        style={{ width: '100%' }}
                        value={ data.department_id }
                        >
                        { departments_list }
                    </Select>
                </span>,
                width: '25%',
                filters: this.state.department_filter,
                onFilter: (value, record) => record.department_name.indexOf(value) === 0,
            },
            {
                title: 'Check List',
                key: 'check_list_name',
                render: ( data ) => <span>
                    <Paragraph editable={{ onChange: ( str ) => this.handleUpdateChecklist( str, data.check_list_id ) }}>{ data.check_list_name }</Paragraph>
                </span>,
                width: '35%',
                ...this.getColumnSearchProps( 'check_list_name' )
            },
            {
                title: 'Check List Type',
                key: 'check_list_type',
                render: ( data ) => <span>
                     <Select
                        value={ data.check_list_type }
                        onChange={ (value) => this.handleUpdateChecklistType( value, data.check_list_id ) }
                        style={{ width: '100%' }}>
                        <Option value="o_b_c">Onboard Checklist</Option>
                        <Option value="e_x_c">Exit Checklist</Option>
                    </Select>
                </span>,
                width: '30%'
            },
            {
                title: 'Action',
                key: 'actions',
                render: ( data ) => <span>
                    <Button 
                        onClick={ () => this.handleDeleteChecklist( data.check_list_id ) }
                        icon="delete" size="small" type="danger" />
                </span>,
                width: '10%'
            }
        ]

        return (
            <div className="checklist_wrapper">

                <Row gutter={16}>
                    <Col span={12}>
                        <h2>
                            <Icon type="check-square" />
                            &nbsp; Check List 
                        </h2>
                    </Col>
                    <Col span={12}>
                        <Button
                            onClick={ ()=> this.setState({ new_visible: true }) }
                            className="fl_right" 
                            type="primary" >New Check List</Button>

                    </Col>
                </Row>

                <Divider />

                <Row gutter={16}>
                    <Col span={24}>

                        <Table 
                            showSizeChanger={ true }
                            columns={ columns } dataSource={ this.state.data } />

                    </Col>
                </Row>

                {/* New */}
                <Modal
                    title="New Check List"
                    maskClosable={ false }
                    visible={ this.state.new_visible }
                    onOk={ this.handleSubmit }
                    onCancel={ this.handleCancel }>
                    <Row>
                        <Col span={24}>

                            <Row>
                                <Col span={24} className="mrg_b_15">
                                    <label>Select Department</label>
                                    <Select 
                                        value={ this.state.department_id }
                                        onChange={ ( value ) => this.setState({ department_id: value  }) }
                                        style={{ width: '100%' }}>
                                        <Option value={ 0 }>None</Option>
                                        { departments_list }
                                    </Select>
                                </Col>
                            </Row>

                            <Row>
                                <Col span={24} className="mrg_b_15">
                                    <label>Check List Type</label>
                                    <Select
                                        value={ this.state.check_list_type }
                                        onChange={ (value) => this.setState({ check_list_type: value }) }
                                        style={{ width: '100%' }}>
                                        <Option value="o_b_c">Onboard Checklist</Option>
                                        <Option value="e_x_c">Exit Checklist</Option>
                                    </Select>
                                </Col>
                            </Row>

                            <Row>
                                <Col span={24}>
                                    <label>Check List</label>
                                    <Input 
                                        value={ this.state.check_list_name }
                                        onChange={ ( e ) => this.setState({ check_list_name: e.target.value }) } />
                                </Col>
                            </Row>

                        </Col>
                    </Row>
                </Modal>

            </div>
        )
    }
}

function mapStateToProps( state ) {
    return {
        checklist: state.checklist
    }
}

export default connect( mapStateToProps, { 
    get_ch_department, 
    save_checklist,
    get_checklist,
    delete_checklist,
    update_checklist_department,
    update_checklist,
    update_checklist_type })( CheckList );


// WEBPACK FOOTER //
// ./src/pages/check_list/index.js